const { useState, useEffect } = require('react')
const { useLocation, useNavigationType } = require('react-router-dom')
const get = require('lodash/get')

// Custom hook to store navigation history stack
function useHistoryStack() {
  const [stack, setStack] = useState([])
  const location = useLocation()
  const type = useNavigationType()

  useEffect(() => {
    switch (type) {
      case 'POP':
        if (stack.length === 0) {
          setStack([location])
        } else {
          setStack(prev => prev.slice(0, prev.length - 1))
        }
        break
      case 'PUSH':
        setStack(prev => [...prev, location])
        break
      case 'REPLACE':
        {
          const reset = get(location, 'state.reset', true)

          if (reset) {
            setStack(() => [location])
          } else {
            setStack(prev => [...prev.slice(0, prev.length - 1), location])
          }
        }
        break
      default:
        setStack(prev => [...prev.slice(0, prev.length - 1), location])
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, type])

  return stack
}

export default useHistoryStack
